export default "__VITE_ASSET__c468020c__"